var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2259_8249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6644 12.0047L10.3359 13.9358V10.0642L13.6644 12.0047Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9267 7.48584H8.07303C7.75918 7.48584 7.4484 7.54768 7.15845 7.66784C6.86851 7.78799 6.60509 7.9641 6.38323 8.1861C6.16138 8.40811 5.98544 8.67165 5.86548 8.96167C5.74551 9.25169 5.68388 9.56251 5.68408 9.87637V14.1237C5.68388 14.4376 5.74551 14.7484 5.86548 15.0384C5.98544 15.3285 6.16138 15.592 6.38323 15.814C6.60509 16.036 6.86851 16.2121 7.15845 16.3323C7.4484 16.4524 7.75918 16.5143 8.07303 16.5143H15.9267C16.2406 16.5143 16.5513 16.4524 16.8413 16.3323C17.1312 16.2121 17.3947 16.036 17.6165 15.814C17.8384 15.592 18.0143 15.3285 18.1343 15.0384C18.2542 14.7484 18.3159 14.4376 18.3157 14.1237V9.87637C18.3159 9.56251 18.2542 9.25169 18.1343 8.96167C18.0143 8.67165 17.8384 8.40811 17.6165 8.1861C17.3947 7.9641 17.1312 7.78799 16.8413 7.66784C16.5513 7.54768 16.2406 7.48584 15.9267 7.48584ZM10.3357 13.9358V10.0643L13.6641 12.0001L10.3357 13.9358Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2259_8249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.027d456974e6d874f7381f8b11864881.svg";
export { ForwardRef as ReactComponent };